import { client } from '../actions/';
import moment from 'moment';
import { parseToken } from '../helpers/dspx-utils'
import appSettings from '../constants/app.constants'

export const userService = {
  login,
  logout,
  refresh,
  authenticateWithCheckTwofact,
  authenticateWithCheckVerificationCode,
};

function _saveUser({user}) {
    if(!user||!user.access) return
    const u = parseToken(user.access)
    const d = moment().diff(moment(u.nbf * 1000), 'seconds', true)
    const e = moment(u.exp * 1000).add(d, 'seconds')
    const l = moment(e).diff(moment(), 'seconds', true)  
    const data = { ...user, expire: e, ttl: l }
    localStorage.setItem('user', JSON.stringify(data));
}

function _loginFail({err}) {
    const r = err.request;
    const error = (r && r.status === 401 ? 'Логин или пароль указан неверно!' : err);
    throw(error);
}

async function login(username, password) {
  try {
        const res = await client.post(`${appSettings.apiUrl}/auth`, { Login: username, Password: password });        
        _saveUser({ user: res.data });
        return res.data;
    } catch (err) {
        _loginFail({ err });
    }
}

async function authenticateWithCheckTwofact(username, password) {
  try {
    const res = await client.post(
      `${appSettings.apiUrl}/TwoFactAuth/authenticate_with_check_twofact`,
      { login: username, password: password }
    );
    const tokenPayload = res.data?.token || res.data;
    if (tokenPayload?.access) {
      _saveUser({ user: tokenPayload });
    }
    return res.data;
  } catch (err) {
    _loginFail({ err });
  }
}

async function authenticateWithCheckVerificationCode(username, password, code) {
  try {
    const res = await client.post(
      `${appSettings.apiUrl}/TwoFactAuth/authenticate_with_check_verification_code`,
      { login: username, password: password, code }
    );
    _saveUser({ user: res.data?.token });
    return res.data;
  } catch (err) {
    _loginFail({ err });
  }
}

async function refresh(token) {
  try {
        const res = await client.post(`${appSettings.apiUrl}/auth/refresh`, `"${token}"`, { headers: { 'Content-Type': 'application/json' } });
        _saveUser({ user: res.data });
        return res.data;
    } catch (err) {
        _loginFail({ err });
    }
}

function logout() {
    localStorage.removeItem('user');
}
